module.exports = __webpack_public_path__ + "static/media/service_gallery.5d2d6ab3.png";